import React from 'react';
import { Popover as BasePopover } from '@base-ui-components/react/popover';

// Controlled overlay positioned against an external target element —
// react-bootstrap's <Overlay show target container> API. Dismissal stays
// the caller's job (onHide fires on outside press / escape via Base UI).

const SIDE = { top: 'top', bottom: 'bottom', left: 'left', right: 'right' };

/**
 * @param {object} props
 * @param {boolean} [props.show=false] Controlled visibility.
 * @param {Element|null} [props.target] Anchor element to position against.
 * @param {Element} [props.container] Portal container (e.g. useModalContainer()).
 * @param {'top'|'bottom'|'left'|'right'} [props.placement='bottom']
 * @param {() => void} [props.onHide] Fires on outside press / Escape.
 */
const Overlay = ({ show = false, target, container, placement = 'bottom', onHide, children }) => (
  <BasePopover.Root
    open={show}
    modal={false}
    onOpenChange={(open) => {
      if (!open && onHide) onHide();
    }}
  >
    <BasePopover.Portal container={container || undefined}>
      <BasePopover.Positioner anchor={target || undefined} side={SIDE[placement] || 'bottom'} sideOffset={6}>
        <BasePopover.Popup>{children}</BasePopover.Popup>
      </BasePopover.Positioner>
    </BasePopover.Portal>
  </BasePopover.Root>
);

export default Overlay;
